export const homeStrings = {
    en:{
        // homeWelcome:"Welcome, I'm...",
        // homeIm1:"Wojciech Nowogrodzki",
        homeIm2:"I build and maintain IT systems for small and medium businesses",
        homeIm3:"I automate business processes with AI",
        homeIm4:"Your technology partner — from idea to production",
        homeIm5:"I solve IT problems so you can focus on your business",
        homeHireMe:"Free consultation",
    },
    pl: {
        // homeWelcome:"Dzień dobry, jestem...",
        // homeIm1:"Wojciech Nowogrodzki",
        homeIm2:"Buduję i utrzymuję systemy IT dla małych i średnich firm",
        homeIm3:"Automatyzuję procesy biznesowe z AI",
        homeIm4:"Twój partner technologiczny — od pomysłu do wdrożenia",
        homeIm5:"Rozwiązuję problemy IT, żebyś skupił się na biznesie",
        homeHireMe:"Bezpłatna konsultacja",
    },
};

export default homeStrings;